module.exports = __webpack_public_path__ + "img/advant2.74a0077e.png";